module.exports = __webpack_public_path__ + "static/media/landing-logos-d.9988525f.png";